import { Box, Stack, Text, Tooltip } from '@mantine/core'
import React from 'react'

import UserDetails from '@/components/Details/UserDetails/UserDetails'
import { LAMINA1_OFFICIAL_ADDRESS } from '@/constants/blockchain'
import { formattedDateTime } from '@/utils/utils'

import { AccessConditions } from './Content'
import classes from './style.module.css'

interface PostHeaderProps {
  timestamp?: string
  accessConditions?: AccessConditions
}

const PostHeader: React.FC<PostHeaderProps> = ({ timestamp, accessConditions }) => (
  <Stack
    gap="20px"
    style={{
      flexDirection: 'row',
    }}
  >
    <Stack
      gap="5px"
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'flex-start',
      }}
    >
      <UserDetails userId={LAMINA1_OFFICIAL_ADDRESS} />
      <Stack style={{ alignItems: 'flex-end' }}>
        <Stack style={{ flexDirection: 'row', gap: '6px', alignItems: 'center' }}>
          {accessConditions &&
            (Object.keys(accessConditions) as (keyof AccessConditions)[]).map(key => {
              const condition = accessConditions[key]
              return (
                condition.display && (
                  <Tooltip
                    key={key}
                    label={
                      condition.approved ? condition.hasAccess.tooltip : condition.getAccess.tooltip
                    }
                    position="top"
                  >
                    <Box>
                      {condition.approved ? condition.hasAccess.icon : condition.getAccess.icon}
                    </Box>
                  </Tooltip>
                )
              )
            })}
          <Text className={classes.timestamp}>•</Text>
          {timestamp && (
            <Text className={classes.timestamp} style={{ whiteSpace: 'nowrap' }}>
              {formattedDateTime(timestamp)}
            </Text>
          )}
        </Stack>
      </Stack>
    </Stack>
  </Stack>
)

export default PostHeader
